'use strict';

var TOOL_TIPS_POSITIONS = {
  TOP: {
    bottom: "-5px",
    right: "50%",
    transform: "translate(-50%, -120%)"
  },
  BOTTOM: {
    top: "-5px",
    right: "50%",
    transform: "translate(-50%, 10%)"
  },
  RIGHT: {
    top: "50%",
    left: "-5px",
    transform: "translate(8%, -60%)"
  },
  LEFT: {
    top: "50%",
    right: "-5px",
    transform: "translate(-120%, -60%)"
  }
};

var COMPONENT_TOOL_TIPS_POSITIONS = {
  TOP: {
    bottom: "-5px",
    right: "50%",
    transform: "translate(-55%, -120%)"
  },
  BOTTOM: {
    top: "-5px",
    right: "50%",
    transform: "translate(-55%, 20%)"
  },
  RIGHT: {
    top: "50%",
    left: "-5px",
    transform: "translate(3%, -53%)"
  },
  LEFT: {
    top: "50%",
    right: "-5px",
    transform: "translate(-120%, -60%)"
  }
};

exports.COMPONENT_TOOL_TIPS_POSITIONS = COMPONENT_TOOL_TIPS_POSITIONS;
exports.TOOL_TIPS_POSITIONS = TOOL_TIPS_POSITIONS;
//# sourceMappingURL=const-7e9ce2ed.js.map
